export default __webpack_public_path__ + "static/media/borra-radha-krishna.087a5075.png";